import { TreeDiagram } from './components/TreeDiagram';

declare global {
    interface Window {
        TreeDiagram: typeof TreeDiagram;
    }
}

function init() {
    window.TreeDiagram = TreeDiagram;
}

init();
